window.theme = window.theme || {};
window.slate = window.slate || {};

// Flag that JS is running (the one Modernizr job still needed).
document.documentElement.classList.replace('no-js', 'js');

// "Continue shopping" on the cart returns to the last collection visited this session (default: Deals).
// sessionStorage throws when storage is blocked; the link then keeps its default.
document.addEventListener('DOMContentLoaded', function() {
  try {
    if (document.body.classList.contains('template-collection')) {
      sessionStorage.setItem('lastCollectionUrl', location.pathname + location.search);
    }
    var lastCollectionUrl = sessionStorage.getItem('lastCollectionUrl');
    if (lastCollectionUrl) {
      document.querySelectorAll('[data-continue-shopping]').forEach(function(link) {
        link.href = lastCollectionUrl;
      });
    }
  } catch (e) {}
});

// Prefix for a root-relative path in the current locale: '' on the primary locale, '/ja' on /ja/.
// Section Rendering requests must use it, or Shopify renders them in the primary language.
theme.localePath = function(path) {
  var root = (theme.routes && theme.routes.root) || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  return root.replace(/\/+$/, '') + path;
};

// A page restored from the back/forward cache keeps the header cart total it was left with
// (eg. back after emptying the cart), so re-render the badge from the header section.
window.addEventListener('pageshow', function(event) {
  var badge = event.persisted && document.getElementById('CartCount');
  if (!badge) return;
  fetch(theme.localePath('/?sections=header'))
    .then(function(res) { return res.json(); })
    .then(function(sections) {
      var fresh = new DOMParser().parseFromString(sections.header, 'text/html').getElementById('CartCount');
      if (fresh) badge.replaceWith(fresh);
    })
    .catch(function() {});
});

// Query string as an object; theme.Filters keeps sort_by etc. across tag navigations.
// A repeated key (filter.p.vendor=A&filter.p.vendor=B) becomes an array so no value is lost.
window.Shopify = window.Shopify || {};
Shopify.queryParams = {};
new URLSearchParams(location.search).forEach(function(value, key) {
  var existing = Shopify.queryParams[key];
  if (existing === undefined) Shopify.queryParams[key] = value;
  else if (Array.isArray(existing)) existing.push(value);
  else Shopify.queryParams[key] = [existing, value];
});

// Port of the prepareTransition plugin (Jonathan Snook, MIT): reflow before a
// transitioned class change, then drop 'is-transitioning' when it ends.
theme.prepareTransition = function(el) {
  if (!el) return;

  el.addEventListener(
    'transitionend',
    function handler() {
      el.classList.remove('is-transitioning');
      el.removeEventListener('transitionend', handler);
    },
    { once: true }
  );

  var duration = parseFloat(getComputedStyle(el).transitionDuration) || 0;
  if (duration !== 0) {
    el.classList.add('is-transitioning');
    void el.offsetWidth; // force reflow so the class change above takes effect immediately
  }
};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
  document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
  document.addEventListener('shopify:section:select', this._onSelect.bind(this));
  document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
  document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
  document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (constructor === undefined) {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = evt.target.querySelector('[data-section-id]');
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter(function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (instance !== undefined && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (instance !== undefined && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (instance !== undefined && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (instance !== undefined && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    var self = this;
    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(function(container) {
      self._createInstance(container, constructor);
    });
  }
});

window.slate = window.slate || {};

// Rich-text helpers. Video embeds are sized in CSS (product-new.css.liquid): wrapping them
// here moved each iframe in the DOM, which made it load twice.
slate.rte = (function() {
  function wrapElement(el, wrapperClass) {
    var wrapper = document.createElement('div');
    wrapper.className = wrapperClass;
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  }

  return {
    wrapTable: function() {
      document.querySelectorAll('.rte table').forEach(function(table) {
        wrapElement(table, 'rte__table-wrapper');
      });
    }
  };
})();

window.slate = window.slate || {};

// Accessibility helpers: focus management for in-page links, drawers and modals.

slate.a11y = (function() {
  var trapFocusHandlers = {};

  return {
    // Move focus to a container (e.g. after an in-page link) so the next Tab starts there.
    pageLinkFocus: function(element) {
      if (!element) return;

      var focusClass = 'js-focus-hidden';

      function callback() {
        element.classList.remove(focusClass);
        element.removeAttribute('tabindex');
      }

      element.setAttribute('tabIndex', '-1');
      element.focus();
      element.classList.add(focusClass);
      element.addEventListener('blur', callback, { once: true });
    },

    // Keep focus inside options.container until removeTrapFocus; namespace keys the listener.
    trapFocus: function(options) {
      var namespace = options.namespace || 'default';

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();

      var handler = function(evt) {
        if (options.container !== evt.target && !options.container.contains(evt.target)) {
          options.container.focus();
        }
      };

      trapFocusHandlers[namespace] = handler;
      document.addEventListener('focusin', handler);
    },

    // Undo trapFocus for options.namespace.
    removeTrapFocus: function(options) {
      var namespace = options.namespace || 'default';

      if (options.container) {
        options.container.removeAttribute('tabindex');
      }

      var handler = trapFocusHandlers[namespace];
      if (handler) {
        document.removeEventListener('focusin', handler);
        delete trapFocusHandlers[namespace];
      }
    }
  };
})();

// Only the left nav drawer exists, so the left-hand classes are fixed here.
window.Drawers = (function() {
  var Drawer = function(id, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-left',
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-left'
    };

    this.nodes = {
      parent: [document.body, document.documentElement]
    };

    this.config = Object.assign(defaults, options);

    this.drawer = document.getElementById(id);
    this.openEls = document.querySelectorAll(this.config.open);

    if (!this.drawer) {
      return;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    var self = this;

    this.openEls.forEach(function(el) {
      el.setAttribute('aria-expanded', 'false');
      el.addEventListener('click', self.open.bind(self));
    });

    this.drawer.querySelectorAll(this.config.close).forEach(function(el) {
      el.addEventListener('click', self.close.bind(self));
    });

    // Covers the page while open: tapping it closes the drawer, and it swallows page scrolling.
    this.backdrop = document.createElement('div');
    this.backdrop.className = 'drawer-backdrop';
    this.backdrop.addEventListener('click', this.close.bind(this));
    this.backdrop.addEventListener('touchmove', function(evt) { evt.preventDefault(); }, { passive: false });
    document.body.appendChild(this.backdrop);
  };

  Drawer.prototype.open = function(evt) {
    // don't open an opened drawer
    if (this.drawerIsOpen) {
      return;
    }

    this.openEls.forEach(function(el) {
      el.classList.add(this.config.openClass);
    }, this);

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
      this.activeSource = evt.currentTarget;
    }

    this.nodes.parent.forEach(function(el) {
      el.classList.add(this.config.openClass, this.config.dirOpenClass);
    }, this);
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      container: this.drawer,
      namespace: 'drawer_focus'
    });

    if (this.activeSource && this.activeSource.getAttribute('aria-expanded') !== null) {
      this.activeSource.setAttribute('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Drawer.prototype.close = function() {
    // don't close a closed drawer
    if (!this.drawerIsOpen) {
      return;
    }

    this.openEls.forEach(function(el) {
      el.classList.remove(this.config.openClass);
    }, this);

    // deselect any focused form elements
    if (document.activeElement) document.activeElement.blur();

    this.nodes.parent.forEach(function(el) {
      el.classList.remove(this.config.dirOpenClass, this.config.openClass);
    }, this);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      container: this.drawer,
      namespace: 'drawer_focus'
    });

    if (this.activeSource && this.activeSource.getAttribute('aria-expanded') !== null) {
      this.activeSource.setAttribute('aria-expanded', 'false');
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    var self = this;

    this._onParentKeyupHandler = function(evt) {
      if (evt.keyCode === 27) {
        self.close();
      }
    };

    // Pressing escape closes drawer
    this.nodes.parent.forEach(function(el) {
      el.addEventListener('keyup', self._onParentKeyupHandler);
    });
  };

  Drawer.prototype.unbindEvents = function() {
    var self = this;

    this.nodes.parent.forEach(function(el) {
      el.removeEventListener('keyup', self._onParentKeyupHandler);
    });
  };

  return Drawer;
})();

window.Meganav = (function() {
  function siblings(el, selector) {
    var result = [];
    var parent = el.parentElement;
    if (!parent) return result;
    Array.prototype.forEach.call(parent.children, function(child) {
      if (child !== el && child.matches(selector)) {
        result.push(child);
      }
    });
    return result;
  }

  function directChild(parentEl, selector) {
    if (!parentEl) return null;
    return (
      Array.prototype.filter.call(parentEl.children, function(child) {
        return child.matches(selector);
      })[0] || null
    );
  }

  function forEachEl(list, fn) {
    Array.prototype.forEach.call(list || [], fn);
  }

  var Meganav = function(options) {
    this.page = document.querySelectorAll('.page-element');

    var defaults = {
      meganavsSelector: '.meganav',
      meganavToggleSelector: '.meganav-toggle',
      meganavDropdownContainers: document.querySelectorAll('.site-nav__dropdown-container'),
      meganavToggleThirdLevel: document.querySelectorAll('.meganav__link-toggle'),
      meganavLinkSecondLevel: document.querySelectorAll('.meganav__link--second-level'),
      meganavLinkThirdLevel: document.querySelectorAll('.meganav__link--third-level'),
      meganavDropdownThirdLevelSelector: '.site-nav__dropdown--third-level',
      isOpen: false,
      preventDuplicates: false,
      closeOnPageClick: false,
      closeThirdLevelOnBlur: false,
      activeClass: 'meganav--active',
      drawerClass: 'meganav--drawer',
      meganavDropdown: '.site-nav__dropdown',
      drawerToggleClass: 'drawer__nav-toggle-btn',
      drawerNavItem: '.drawer__nav-item',
      thirdLevelClass: 'meganav__link-toggle',
      noAnimationClass: 'meganav--no-animation'
    };

    this.config = Object.assign(defaults, options);
    this.toggleEls = document.querySelectorAll(this.config.meganavToggleSelector);
    this.init();
  };

  Meganav.prototype.init = function() {
    var self = this;

    forEachEl(this.toggleEls, function(el) {
      el.addEventListener('click', self.requestMeganav.bind(self));
    });

    if (this.config.closeThirdLevelOnBlur) {
      forEachEl(this.config.meganavLinkThirdLevel, function(el) {
        el.addEventListener('blur', self.closeThirdLevelMenu.bind(self));
      });
    }
  };

  Meganav.prototype.requestMeganav = function(evt) {
    var targetedMeganav;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    }

    // Without this, the meganav opens, the click event bubbles up to
    // this.page which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    var el = evt.currentTarget;
    var anotherNavIsOpen = this.config.isOpen;
    var isThirdLevelBtn = el.classList.contains(this.config.thirdLevelClass);

    // The targeted meganav is different for the drawer and non-drawer navs
    if (el.classList.contains(this.config.drawerToggleClass)) {
      var navItem = el.closest(this.config.drawerNavItem);
      targetedMeganav = directChild(navItem, '.' + this.config.drawerClass);
    } else {
      targetedMeganav = siblings(el, this.config.meganavDropdown)[0] || null;
    }

    // Navigate to link href or close menu if already active
    if (el.classList.contains(this.config.activeClass) && el.tagName === 'A') {
      window.location = el.getAttribute('href');
      return;
    }

    // If true, don't let multiple meganavs be open simultaneously
    if (!isThirdLevelBtn && this.config.preventDuplicates) {
      this.close();
    }

    if (!targetedMeganav) return;

    if (targetedMeganav.classList.contains(this.config.drawerClass)) {
      var isExpanded = el.getAttribute('aria-expanded') === 'true';

      el.classList.toggle(this.config.activeClass);
      el.setAttribute('aria-expanded', String(!isExpanded));

      this._slideToggle(targetedMeganav, 200);
    } else {
      el.classList.add(this.config.activeClass);
      el.setAttribute('aria-expanded', 'true');

      // Show targeted nav, letting it know whether another meganav is already open
      this.open(el, targetedMeganav, anotherNavIsOpen);
    }

    // Setup event handlers when meganav is open
    this.bindEvents();
    this.config.isOpen = true;
  };

  // Height animation for drawer submenus, which are display:none by default
  // (the desktop dropdown animates in CSS).
  Meganav.prototype._slideToggle = function(el, duration) {
    var isHidden = getComputedStyle(el).display === 'none';

    el.style.transition = 'none';

    if (isHidden) {
      el.style.display = 'block';
      var targetHeight = el.scrollHeight;
      el.style.height = '0px';
      void el.offsetHeight; // force reflow so the height:0 above takes effect first
      el.style.transition = 'height ' + duration + 'ms ease';
      el.style.height = targetHeight + 'px';

      el.addEventListener(
        'transitionend',
        function handler() {
          el.style.height = '';
          el.style.transition = '';
          el.removeEventListener('transitionend', handler);
        },
        { once: true }
      );
    } else {
      var currentHeight = el.scrollHeight;
      el.style.height = currentHeight + 'px';
      void el.offsetHeight; // force reflow
      el.style.transition = 'height ' + duration + 'ms ease';
      el.style.height = '0px';

      el.addEventListener(
        'transitionend',
        function handler() {
          el.style.display = 'none';
          el.style.height = '';
          el.style.transition = '';
          el.removeEventListener('transitionend', handler);
        },
        { once: true }
      );
    }
  };

  Meganav.prototype.open = function(el, target, noAnimation) {
    var isThirdLevelBtn = el.classList.contains(this.config.thirdLevelClass);

    target.classList.add(this.config.activeClass);

    if (isThirdLevelBtn) {
      this.toggleSubNav(el, target);
    }

    // Add class to override animation - CSS determined
    if (noAnimation) {
      target.classList.add(this.config.noAnimationClass);
    }
  };

  Meganav.prototype.toggleSubNav = function(el) {
    this.removeMenuActiveState();

    el.classList.add(this.config.activeClass);
    el.setAttribute('aria-expanded', 'true');

    siblings(el, this.config.meganavDropdownThirdLevelSelector).forEach(function(sibling) {
      sibling.classList.add(this.config.activeClass);
    }, this);

    if (el.parentElement) {
      el.parentElement.classList.add(this.config.activeClass);
    }
  };

  Meganav.prototype.close = function(evt, target) {
    var self = this;

    if (this.config.preventDuplicates) {
      // Close all meganavs
      document.querySelectorAll(this.config.meganavsSelector).forEach(function(el) {
        el.classList.remove(self.config.activeClass, self.config.noAnimationClass);
      });
      forEachEl(this.toggleEls, function(el) {
        el.classList.remove(self.config.activeClass);
        el.setAttribute('aria-expanded', 'false');
      });
      forEachEl(this.config.meganavDropdownContainers, function(el) {
        el.classList.remove(self.config.activeClass);
      });
    } else if (target) {
      // Close targeted nav
      var targetId = target.getAttribute('aria-controls');
      var targetedMeganav = targetId ? document.getElementById(targetId) : null;
      if (targetedMeganav) {
        targetedMeganav.classList.remove(this.config.activeClass, this.config.noAnimationClass);
      }
      target.classList.remove(this.config.activeClass);
      target.setAttribute('aria-expanded', 'false');
    }

    // Remove event listeners
    this.unbindEvents();
    this.config.isOpen = false;
  };

  Meganav.prototype.closeThirdLevelMenu = function(evt) {
    var el = evt.currentTarget;
    var parent = el.parentElement;

    if (!parent || !parent.parentElement || parent !== parent.parentElement.lastElementChild) {
      return;
    }

    var self = this;
    forEachEl(this.config.meganavLinkSecondLevel, function(secondLevelEl) {
      secondLevelEl.addEventListener(
        'focus',
        function handler() {
          self.removeMenuActiveState();
          secondLevelEl.removeEventListener('focus', handler);
        },
        { once: true }
      );
    });
  };

  Meganav.prototype.removeMenuActiveState = function() {
    var self = this;

    forEachEl(this.config.meganavToggleThirdLevel, function(el) {
      el.classList.remove(self.config.activeClass, self.config.noAnimationClass);
      el.setAttribute('aria-expanded', 'false');
    });

    document.querySelectorAll(this.config.meganavDropdownThirdLevelSelector).forEach(function(el) {
      el.classList.remove(self.config.activeClass, self.config.noAnimationClass);
    });

    forEachEl(this.config.meganavDropdownContainers, function(el) {
      el.classList.remove(self.config.activeClass);
    });
  };

  Meganav.prototype.bindEvents = function() {
    if (!this.config.closeOnPageClick) {
      return;
    }

    var self = this;
    this.unbindEvents();

    // Clicking away from the meganav will close it
    this._onPageClickHandler = function(evt) {
      self.close(evt);
    };
    forEachEl(this.page, function(el) {
      el.addEventListener('click', self._onPageClickHandler);
    });

    // Exception to above: clicking anywhere on the meganav will NOT close it
    this._onMeganavClickHandler = function(evt) {
      evt.stopPropagation();
    };
    document.querySelectorAll(this.config.meganavsSelector).forEach(function(el) {
      el.addEventListener('click', self._onMeganavClickHandler);
    });

    // Pressing escape closes meganav and focuses the target parent link
    this._onDocumentKeyupHandler = function(evt) {
      if (evt.keyCode !== 27) return;

      var activeToggle = null;
      forEachEl(self.toggleEls, function(el) {
        if (el.classList.contains(self.config.activeClass)) activeToggle = el;
      });
      if (activeToggle) activeToggle.focus();
      self.close();
    };
    document.addEventListener('keyup', this._onDocumentKeyupHandler);
  };

  Meganav.prototype.unbindEvents = function() {
    if (!this.config.closeOnPageClick) {
      return;
    }

    var self = this;

    if (this._onPageClickHandler) {
      forEachEl(this.page, function(el) {
        el.removeEventListener('click', self._onPageClickHandler);
      });
    }
    if (this._onMeganavClickHandler) {
      document.querySelectorAll(this.config.meganavsSelector).forEach(function(el) {
        el.removeEventListener('click', self._onMeganavClickHandler);
      });
    }
    if (this._onDocumentKeyupHandler) {
      document.removeEventListener('keyup', this._onDocumentKeyupHandler);
    }
  };

  return Meganav;
})();

window.Notify = (function() {
  var notify = function() {
    this.initCache();

    this.settings = {
      notifyActiveClass: 'notification--active',
      closeTimer: 5000
    };

    this.notifyTimer = null;
    this.lastFocusedElement = null;

    var self = this;
    this.cache.notificationClose.forEach(function(el) {
      el.addEventListener('click', self.close.bind(self));
    });
  };

  notify.prototype.initCache = function() {
    this.cache = {
      notificationSuccess: document.getElementById('NotificationSuccess'),
      notificationSuccessLink: document.querySelector('#NotificationSuccess a'),
      notificationError: document.getElementById('NotificationError'),
      notificationClose: document.querySelectorAll('.notification-close'),
      notificationErrorMessage: document.querySelector('.notification__message--error')
    };
  };

  notify.prototype.open = function(state, message, autoclose) {
    var self = this;
    this.close();

    if (state === 'success') {
      if (this.cache.notificationSuccess) {
        this.cache.notificationSuccess.setAttribute('aria-hidden', 'false');
        this.cache.notificationSuccess.classList.add(this.settings.notifyActiveClass);

        // Set last focused element to return to once success
        // notification is dismissed (by timeout)
        this.lastFocusedElement = document.activeElement;

        // Set focus on link to cart after transition
        this.cache.notificationSuccess.addEventListener(
          'transitionend',
          function() {
            slate.a11y.pageLinkFocus(self.cache.notificationSuccessLink);
          },
          { once: true }
        );
      }
    } else {
      if (this.cache.notificationErrorMessage) {
        this.cache.notificationErrorMessage.textContent = message;
      }
      if (this.cache.notificationError) {
        this.cache.notificationError.setAttribute('aria-hidden', 'false');
        this.cache.notificationError.classList.add(this.settings.notifyActiveClass);
      }
    }

    // Timeout to close the notification
    if (autoclose) {
      clearTimeout(this.notifyTimer);
      this.notifyTimer = setTimeout(
        this.close.bind(this),
        this.settings.closeTimer
      );
    }
  };

  notify.prototype.close = function() {
    // Return focus to previous element if one is defined
    // and the user has not strayed from the success notification link
    if (
      this.lastFocusedElement &&
      this.cache.notificationSuccessLink &&
      document.activeElement === this.cache.notificationSuccessLink
    ) {
      slate.a11y.pageLinkFocus(this.lastFocusedElement);
    }

    // Close all notification bars
    if (this.cache.notificationSuccess) {
      this.cache.notificationSuccess.setAttribute('aria-hidden', 'true');
      this.cache.notificationSuccess.classList.remove(this.settings.notifyActiveClass);
    }
    if (this.cache.notificationError) {
      this.cache.notificationError.setAttribute('aria-hidden', 'true');
      this.cache.notificationError.classList.remove(this.settings.notifyActiveClass);
    }

    // Reset last focused element
    this.lastFocusedElement = null;
  };

  return notify;
})();

theme.headerNav = (function() {
  var config = {
    searchShowClass: 'site-header__search-input--visible',
    searchInputClass: 'header-search-input',
    searchSubmitClass: 'header-search-submit',
    searchInnerActiveClass: 'search-header__search-inner--active'
  };

  function init() {
    initMegaNavs();
    initHeaderSearch();
  }

  function initMegaNavs() {
    // Each construction wrapped individually so a throw in one (eg. missing
    // elements for one nav variant) can't skip the other two.
    try {
      new window.Meganav({
        meganavsSelector: '.site-nav__dropdown',
        meganavToggleSelector: '.site-nav__link-toggle',
        preventDuplicates: true,
        closeOnPageClick: true,
        closeThirdLevelOnBlur: true
      });
    } catch (err) {
      console.error('[theme.headerNav] site-nav Meganav threw:', err);
    }

    try {
      new window.Meganav({
        meganavsSelector: '.meganav--index',
        meganavToggleSelector: '.index__meganav-toggle'
      });
    } catch (err) {
      console.error('[theme.headerNav] index Meganav threw:', err);
    }

    try {
      new window.Meganav({
        meganavsSelector: '.meganav--drawer',
        meganavToggleSelector: '.drawer__meganav-toggle'
      });
    } catch (err) {
      console.error('[theme.headerNav] drawer Meganav threw:', err);
    }
  }

  function initHeaderSearch() {
    // form only: the wrapping div shares the class, which bound every listener twice.
    document.querySelectorAll('form.header-search').forEach(function(form) {
      var input = form.querySelector('.' + config.searchInputClass);
      var submit = form.querySelector('.' + config.searchSubmitClass);
      var searchInner = form.querySelector('.header-search-inner');

      if (!input) return;

      input.addEventListener('focus', function() {
        if (searchInner) searchInner.classList.add(config.searchInnerActiveClass);
        input.classList.add(config.searchShowClass);
      });

      input.addEventListener('blur', function() {
        if (searchInner) searchInner.classList.remove(config.searchInnerActiveClass);
        if (input.value) {
          input.classList.add(config.searchShowClass);
        } else {
          input.classList.remove(config.searchShowClass);
        }
      });

      if (submit) {
        submit.addEventListener('click', function(evt) {
          if (input.classList.contains(config.searchShowClass)) {
            return;
          }

          evt.preventDefault();
          input.classList.add(config.searchShowClass);
          input.focus();
        });
      }
    });
  }

  return {
    init: init
  };
})();

theme.HeaderSection = (function() {
  // Each step is isolated: the header registers first on every page, and a throw here would
  // stop every later section from registering.
  function Header() {
    try {
      theme.headerNav.init();
    } catch (err) {
      console.error('[theme.HeaderSection] headerNav.init() threw:', err);
    }
    try {
      theme.Notify = new window.Notify();
    } catch (err) {
      console.error('[theme.HeaderSection] new window.Notify() threw:', err);
    }
    try {
      theme.NavDrawer = new window.Drawers('NavDrawer');
    } catch (err) {
      console.error('[theme.HeaderSection] new window.Drawers() threw:', err);
    }
  }

  return Header;
})();

theme.init = function() {
  slate.rte.wrapTable();

  // Common a11y fixes
  // getElementById, not querySelector: hashes like Facebook's "#_=_" aren't valid selectors and would throw.
  function hashTarget(hash) {
    try {
      return hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
    } catch (e) {
      return null;
    }
  }

  slate.a11y.pageLinkFocus(hashTarget(window.location.hash));

  document.querySelectorAll('.in-page-link').forEach(function(el) {
    el.addEventListener('click', function(evt) {
      slate.a11y.pageLinkFocus(hashTarget(evt.currentTarget.hash));
    });
  });

  document.querySelectorAll('a[href="#"]').forEach(function(el) {
    el.addEventListener('click', function(evt) {
      evt.preventDefault();
    });
  });

  // Page modules (Product, Cart, Filters) exist only where their bundle loads.
  var sections = new theme.Sections();
  sections.register('header', theme.HeaderSection);
  if (typeof theme.Product !== 'undefined') {
    sections.register('product', theme.Product);
  }
  if (typeof theme.Filters !== 'undefined') {
    sections.register('collection-filters', theme.Filters);
  }
  if (typeof theme.Cart !== 'undefined') {
    sections.register('cart', theme.Cart);
  }
};

// DOMContentLoaded fires after all deferred scripts, so page modules exist when sections register.
document.addEventListener('DOMContentLoaded', theme.init);

// Only one audio preview at a time. Delegated (capture, since "play" doesn't
// bubble) so players added later by AJAX collection paging are covered.
document.addEventListener('play', function(evt) {
  if (!(evt.target instanceof HTMLAudioElement)) return;
  document.querySelectorAll('audio').forEach(function(audio) {
    if (audio !== evt.target) audio.pause();
  });
}, true);
